import './dashboard';


import News from './widgets/News';
import Statistics from './widgets/Statistics';
import StatisticsMonthly from './widgets/StatisticsMonthly';
import Notifications from './widgets/Notifications';
import Support from './widgets/Support';
import BarChart from '../components/charts/BarChart';
import DoughnutChart from '../components/charts/DoughnutChart';
//import GridColumnsForm from './modals/GridColumnsForm';
import NotificationsSettings from './modals/NotificationsSettings';
import DropdownMonths from '../components/basic/DropdownMonths';
import DropdownYears from '../components/basic/DropdownYears';


Vue.component('news', News);
Vue.component('statistics', Statistics);
Vue.component('statistics-monthly', StatisticsMonthly);
Vue.component('restaurant-notifications', Notifications);
Vue.component('support', Support);
Vue.component('bar-chart', BarChart);
Vue.component('doughnut-chart', DoughnutChart);
//Vue.component('dashboard-grid-columns-form', GridColumnsForm);
Vue.component('notifications-settings', NotificationsSettings);
Vue.component('dropdown-months', DropdownMonths);
Vue.component('dropdown-years', DropdownYears);


// WEBPACK FOOTER //
// ./resources/assets/admin/js/dashboard/index.js